// removed by extract-text-webpack-plugin
module.exports = {"find":"_24gJQ","list":"_2yiia","item":"_1jNxP","target":"_2VpX0","target-value":"_3LV3T","target-currency-symbol":"_3XImu","target-currency":"_2h59_","fundraising-regulator-logo":"_2oc0y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmIdentityForm/ConfirmIdentityForm.scss
// module id = ./src/components/ConfirmIdentityForm/ConfirmIdentityForm.scss
// module chunks = 5